"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabList = void 0;

var tslib_1 = require("tslib");

var tabs_1 = require("@reach/tabs");

var react_1 = tslib_1.__importStar(require("react"));

var slider_1 = require("../styled/slider");

var tab_list_1 = require("../styled/tab-list");

var tabs_2 = require("../tabs");

var TabList = function TabList(_a) {
  var children = _a.children;
  var selectedIndex = tabs_1.useTabsContext().selectedIndex;
  var pattern = react_1.useContext(tabs_2.TabsContext).pattern;
  var count = react_1.Children.toArray(children).filter(function (c) {
    return !!c;
  }).length;
  return react_1.default.createElement(tab_list_1.TabListRoot, {
    pattern: pattern,
    count: count
  }, children, react_1.default.createElement(slider_1.Slider, {
    pattern: pattern,
    count: count,
    selectedIndex: selectedIndex
  }));
};

exports.TabList = TabList;